module.exports = __webpack_public_path__ + "img/book_xh.6c8af730.svg";